import React, { useEffect, useRef } from 'react'
import OrderContact from './ordercontact'
import { containerIprops } from './ordercontactinterface';
import { ICartContextType } from '../../../ShoppingCart/ShoppingCartPromo/shoppingcartpromointerface';
import { useCartContext } from '../../../ShoppingCart/shoppingcart';
import helperfunctions from '../../../../utils/helperfunctions';

const OrderContactContainer = (props: containerIprops) => {

    const { stepperDetails }: ICartContextType = useCartContext();
    const [isPhoneUpdated, setIsPhoneUpdated] = React.useState(false);

    const refs:any = {
        contactPhoneCountryCode: useRef<HTMLDivElement>(null),
        contactPhone: useRef<HTMLDivElement>(null),
    };

    const scrollToErrorField = () => {
        const errorFields = [
            'contactPhoneCountryCode',
            'contactPhone',
        ];
    
        const firstErrorField = errorFields.find((field) => stepperDetails?.shipment?.error?.[field]);

        if (firstErrorField && refs[firstErrorField].current) {
            refs[firstErrorField].current.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };

    useEffect(() => {
        if (stepperDetails?.shipment?.error && Object.keys(stepperDetails?.shipment?.error) && props?.isNextClick) {
            scrollToErrorField();
        }
    }, [ props?.isNextClick ]);
    
    const onInputChange = (type: string, value: string) => {
        const errorObj = { ...stepperDetails?.shipment?.error };
        setIsPhoneUpdated(false);
        if (type === 'contactPhone') {
            const phoneNum = stepperDetails?.shipment?.contactPhoneCountryCode == "+1" ? value : value?.replace(/\D/g, '');
            const err = { ...errorObj, isInvalidPhone: false, contactPhone: false };
            if (phoneNum) {
                props?.updateShipmentDetails({ ...props?.shipmentDetails, [type]: phoneNum.trim(), error: err })
            } else {
                props?.updateShipmentDetails({ ...props?.shipmentDetails, [type]: '', error: err })
            }
        }
        else {
            onChangeUpdatePhoneCode(type, value);
        }
    }

    const getPhoneData = (value: any, phoneCode: any) => {
        return phoneCode == "+1" ? value : value?.replace(/\D/g, '');
    }

    const onChangeUpdatePhoneCode = (type: string, value: string) => {
        const errorObj = { ...stepperDetails?.shipment?.error };
        if (type === 'contactPhoneCountryCode') {
            const valueSplit = value?.split("|");
            value = valueSplit?.length > 0 ? valueSplit[0] : "";
            const phone = stepperDetails?.shipment?.contactPhone ?? '';
            const inputPhone = value == '+1' ? helperfunctions.formatPhoneNumber(phone) : phone?.replace(/\D/g, '');
            props?.updateShipmentDetails({ ...props?.shipmentDetails, [type]: value, contactPhone: getPhoneData(inputPhone, value), error: { ...errorObj, contactPhoneCountryCode: false } })
            setIsPhoneUpdated(true);
        }
        else {
            props?.updateShipmentDetails({ ...props?.shipmentDetails, [type]: value, error: { ...errorObj, contactPhoneCountryCode: false } })
        }
    }

    const handleIsPhoneUpdated = (isUpdated: boolean) => {
        setIsPhoneUpdated(isUpdated);
    }

    return (
        <OrderContact
            onInputChange={onInputChange}
            shipmentDetails={props?.shipmentDetails}
            getDivRef={props?.getDivRef}
            phoneCodeOption={props?.phoneCodeOption}
            getPhoneData={getPhoneData }
            refs={refs}
            isPhoneUpdated={isPhoneUpdated}
            handleIsPhoneUpdated={handleIsPhoneUpdated} 
        />
    )
}

export default OrderContactContainer